<template id="login">
  <validation-observer ref="validator" v-slot="{ errors }" :slim="true">
    <div class="container">
      <div class="container-member">
        <h1 class="page-title on-header">
          로그인
          <button type="button" class="btn-back"><i class="xi-arrow-left" /></button>
        </h1>
        <form
          id="form-login"
          class="form-login"
          @submit.prevent="onSubmit"
        >
          <fieldset class="form-group form-login-email" :class="{ error: hasError(errors, '이메일')}">
            <label for="email" class="form-label sr-only">이메일</label>
            <validator rules="required" name="이메일">
              <input
                id="email"
                v-model="user.email"
                class="form-field"
                type="text"
                placeholder="이메일"
                name="email"
              >
            </validator>
          </fieldset>
          <fieldset class="form-group form-login-password" :class="{ error: hasError(errors, '비밀번호')}">
            <label for="password" class="form-label sr-only">비밀번호</label>
            <validator rules="required" name="비밀번호">
              <input
                id="password"
                v-model="user.password"
                class="form-field"
                type="password"
                placeholder="비밀번호"
                name="password"
                data-vv-as="비밀번호"
              >
            </validator>
          </fieldset>
          <fieldset class="form-group form-login-else">
            <div class="row">
              <div class="col-left">
                <div class="form-check form-check-inline">
                  <input id="remember_me" type="checkbox" name="remember_me" class="form-check-input">
                  <label for="remember_me" class="form-check-label">
                    로그인 상태 유지
                  </label>
                </div>
              </div>
              <div class="col-right text-right visible-xs">
                <div class="link-else">
                  <router-link to="/find/id" class="text-brand">아이디, 비밀번호를 잊었다면?</router-link>
                </div>
              </div>
            </div>
          </fieldset>
          <div class="form-group submit">
            <button type="submit" class="btn btn_lg btn_full">로그인</button>
          </div>
        </form>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { get, isEmpty } from 'lodash';
import ApiClient, { API } from 'api/client';
import jsonp from 'jsonp';
import config from 'config';
import { mapActions } from 'vuex';
import DialogUtil from 'utils/dialog';
import HeaderUtil from 'utils/header';
import axios from 'axios';
import * as amplitude from '@amplitude/analytics-browser';
import { isWebview } from 'utils/webview/isWebview';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { closeWebView } from 'utils/webview/closeWebView';

export default {
  name: 'LoginEmail',
  components: {},
  mixins: [ApiClient],
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    snsStatus() {
      return this.$store.state.oauth;
    },
  },
  created() {
    const authToken = HeaderUtil.isWebView() ? HeaderUtil.getCookie('auth_token') : HeaderUtil.getCookie('plan_auth_token');
    if (this.$store.state.user.logged && this.$store.state.accessToken === authToken) {
      this.$router.replace('/');
    }
  },
  methods: {
    ...mapActions('user', ['login', 'updateUserId', 'logout']),
    ...mapActions(['updateAccessToken']),
    async onSubmit() {
      const valid = await this.$refs.validator.validate();
      if (valid) {
        this.requestLogin();
      }
    },
    requestLogin() {
      const form = new FormData();
      form.append('email', this.user.email);
      form.append('password', this.user.password);
      axios.post(`${config.login.baseURL}/user/login_for_mobile`, form)
        .then(async res => {
          // 아이디, 비밀번호 요청에 따른 데이터가 유효한지 체크
          if (!(res.data.result == null)) {
            const authToken = get(res.data.result, 'auth_token');
            if (authToken) {
              this.login(res.data.result);
              this.updateAccessToken(authToken);
              const SsoLoginApi = this.getApi(API.SSOLOGIN);
              await SsoLoginApi.createCookie({ cookieName: 'plan_auth_token', accessToken: authToken });
              jsonp(`${config.login.baseURL}/user/get_basic_info?auth_token=${authToken}`, (err, res) => {
                if (!(res.result == null)) {
                  this.updateUserId({ userId: res.result.memberid });
                  window.heap.identify(res.result.memberid);
                  window.gtag('set', 'user_properties', {
                    user_id: res.result.memberid,
                    env: (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('socar.me') > -1) ? 'development' : 'production',
                  });
                  amplitude.setUserId(res.result.memberid);
                  if (!isEmpty(this.$route.query.redirect)) {
                    if (this.$route.query.redirect === 'rental-history') {
                      if (isWebview()) {
                        postMessageToPlanHome('/mypage');
                        closeWebView();
                        return;
                      }
                      window.location.href = config.rentalHistory.baseURL;
                    } else if (this.$route.query.redirect === 'home') {
                      if (isWebview()) {
                        postMessageToPlanHome('/');
                        closeWebView();
                        return;
                      }
                      window.location.href = config.planHome.baseURL;
                    } else {
                      this.$router.replace(decodeURIComponent(this.$route.fullPath.split('redirect=')[1]));
                    }
                  } else {
                    this.$router.replace('/');
                  }
                } else {
                  console.log(err);
                  DialogUtil.alert(res.retMsg);
                }
              });
            }
          } else {
            DialogUtil.alert(res.data.retMsg);
          }
        });
    },
    // requestBasicInfo(loginResult) {
    //   const authToken = get(loginResult, 'auth_token');
    //   jsonp(`${config.login.baseURL}/user/get_basic_info?auth_token=${authToken}`, (err, res) => {
    //     console.log(err);
    //     const isCorpDeferredPayment = get(res.result, 'is_corp_deferred_payment');
    //     const payload = Object.assign(loginResult, { is_corp_deferred_payment: isCorpDeferredPayment });
    //     this.setOauth(payload).then(() => {
    //       this.login(payload);
    //       if (typeof window.appboy !== 'undefined') {
    //         window.appboy.changeUser(loginResult.appboy_id);
    //       }
    //       if (!isEmpty(this.$route.query.redirect)) {
    //         this.$router.push(this.$route.query.redirect + this.$route.hash);
    //       } else {
    //         this.$router.push('/');
    //       }
    //     });
    //   });
    // },
  },
};

</script>
